import { Roles } from "./user";

export type permission = "ADD_NEW_TENANT" | "ADD_USER_TO_TENANT" | "SEE_DOCUMENT_REPORT" | "SEE_DETAILED_REPORT" | "ADD_DOCUMENTTYPE_TO_TENANT" | "SEE_OTHER_MANDANTS";

export const permissionsByRole: { [key in permission]: Roles[] } = {
  ADD_NEW_TENANT: ["ROLE_ADMIN"],
  ADD_DOCUMENTTYPE_TO_TENANT: ["ROLE_ADMIN"],
  ADD_USER_TO_TENANT: ["ROLE_ADMIN"],
  SEE_DETAILED_REPORT: ["ROLE_ADMIN", "ROLE_TENANTADMIN", "ROLE_TENANTADMIN_RESTRICTED"],
  SEE_DOCUMENT_REPORT: ["ROLE_ADMIN", "ROLE_TENANTADMIN", "ROLE_TENANTADMIN_RESTRICTED", "ROLE_SPECIALIST"],
  SEE_OTHER_MANDANTS: ["ROLE_ADMIN"],
  //ADD_USER_TO_TENANT: 2118,
};
export type FEATURE =
  | "workflow"
  | "ocr"
  | "doc-analysis"
  | "webcheck"
  | "netzbeweis"
  | "calculator"
  | "llm"
  | "case-list";
